export const unityCatalogDataCatalog = {
  id: 5,
  title: "Unity Catalog Data Catalog",
  activityId: 6,
  startDate: '2023-01-01',
  endDate: '2024-04-30',
  description: "Designed a Unity Catalog-based data catalog, ensuring GDPR compliance and enabling AI-driven observability with Databricks Genie.",
  categorizedSkills: {
    profession: [
      { name: "Data Governance", weight: 1 },
      { name: "AI", weight: 0.8 }
    ],
    tools: [
      { name: "Unity Catalog", weight: 1 },
      { name: "Databricks", weight: 1 },
      { name: "Atlan", weight: 0.6 },
      { name: "Purview", weight: 0.6 },
      { name: "OvalEdge", weight: 0.6 },
      { name: "Data Hub", weight: 0.6 },
      { name: "Open Metadata", weight: 0.8 }
    ],
    language: [
      { name: "SQL", weight: 0.7 }
    ],
    lead: []
  },
  goal: "Enhance data governance and documentation capabilities while ensuring GDPR compliance",
  detailsFile: "unity-catalog-data-catalog.md", // Reference to markdown file
  metrics: [
  ],
  role: "Data Platform Engineer",
  teamSize: "3",
  git: "inner source",
  link: "inner source",
  isProfessional: true,
  isVisible: true
};
